import { IAppState } from '../../redux';

export function selectServiceIds(state: IAppState): string[] {
  const {
    publishTerms: { serviceIds },
  } = state;

  return serviceIds;
}
